// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IdentityProviderType } from "./IdentityProviderType";
import {
  IdentityProviderTypeFromJSON,
  IdentityProviderTypeFromJSONTyped,
  IdentityProviderTypeToJSON,
  IdentityProviderTypeToJSONTyped,
} from "./IdentityProviderType";

/**
 *
 * @export
 * @interface IdentityProvider
 */
export interface IdentityProvider {
  /**
   *
   */
  id: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  type?: IdentityProviderType | null;
}

/**
 * Check if a given object implements the IdentityProvider interface.
 */
export function instanceOfIdentityProvider(value: object): value is IdentityProvider {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function IdentityProviderFromJSON(json: any): IdentityProvider {
  return IdentityProviderFromJSONTyped(json, false);
}

export function IdentityProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IdentityProvider {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    type:
      json["type"] === undefined
        ? undefined
        : json["type"] === null
        ? null
        : IdentityProviderTypeFromJSON(json["type"]),
  };
}

export function IdentityProviderToJSON(json: any): IdentityProvider {
  return IdentityProviderToJSONTyped(json, false);
}

export function IdentityProviderToJSONTyped(
  value?: IdentityProvider | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    type: IdentityProviderTypeToJSON(value["type"]),
  };
}
